import { HtmlSequence } from "../html-sequence.model";
import { HtmlExpression } from "../html-expression.interface";
import { HtmlExpressionType } from "../html-expression-type.enum";


export class HtmlDirective implements HtmlExpression {
    public readonly type: HtmlExpressionType;
    public readonly name: string;

    public readonly arguments: HtmlSequence[];
    public readonly block?: HtmlSequence;
    public readonly start: number;
    public readonly end: number;

    constructor(name: string, start: number, end: number, args: HtmlSequence[], block?: HtmlSequence) {
        this.type = HtmlExpressionType.Directive;
        this.arguments = args;
        this.block = block;
        this.start = start;
        this.name = name;
        this.end = end;
    }
}